import script from "./ProjectsNew.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsNew.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsNew.vue?vue&type=style&index=0&id=98d4b788&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98d4b788"]])

export default __exports__